import { inject, Injectable } from '@angular/core';
import {
  CheckInFormData,
  CheckInNavigationService
} from '@com-delta-idp/mnx-sitewide-shared-utils';
import { CheckInWidgetFormType } from '../models/check-in-widget.interfaces';
import {
  CHECK_IN_TRIP_BY,
  CHECKIN_SEARCH_TYPE_MAP
} from '../models/constants/check-in-constants';
import { CheckInWidgetBaseService } from './check-in-widget-base.service';

@Injectable({
  providedIn: 'root'
})
export class CheckInWidgetInitializationHelperService extends CheckInWidgetBaseService {
  checkInFormData = {} as CheckInFormData;
  checkInNavigationService = inject(CheckInNavigationService);

  redirectFunction(form: CheckInWidgetFormType, redirectUrl: string): void {
    this.populateCheckInFormData(form, redirectUrl);
  }

  private populateCheckInFormData(
    form: CheckInWidgetFormType,
    redirectUrl: string
  ): void {
    const tripType = form.findTripBy?.value?.toLowerCase();
    const tripValue = form.findTripByValue?.value;
    if (tripValue && tripType) {
      this.createCheckInFormData(tripType, tripValue);
    }
    this.setOtherValues(form);
    this.checkInNavigationService.navigateToCheckInFindPNR(
      this.checkInFormData,
      redirectUrl
    );
  }

  createCheckInFormData(tripType: string, tripValue: string): void {
    switch (tripType) {
      case CHECK_IN_TRIP_BY.CONFIRMATION_NUMBER.toLowerCase():
        this.checkInFormData.confirmationNumber = tripValue;
        break;
      case CHECK_IN_TRIP_BY.CREDIT_CARD_NUMBER.toLowerCase():
        this.checkInFormData.creditcardNumber = tripValue;
        break;
      default:
        this.setSkymilesOrTicket(tripType, tripValue);
        break;
    }
  }

  setSkymilesOrTicket(tripType: string, tripValue: string): void {
    switch (tripType) {
      case CHECK_IN_TRIP_BY.SKYMILES_NUMBER.toLowerCase():
        this.checkInFormData.skymilesNumber = tripValue;
        break;
      case CHECK_IN_TRIP_BY.TICKET_NUMBER.toLowerCase():
        this.checkInFormData.eticketNumber = tripValue;
        break;
    }
  }

  setOtherValues(form: CheckInWidgetFormType): void {
    if (form?.lastName?.value)
      this.checkInFormData.lastName = form.lastName.value;
    if (form?.originAirportCode?.value)
      this.checkInFormData.departureAirport = form.originAirportCode.value;
    if (form?.findTripBy?.value)
      this.checkInFormData.searchType =
        CHECKIN_SEARCH_TYPE_MAP[form.findTripBy.value];
  }
}
